import { MessageConst } from 'enums'
import { isValidNumber } from './chartValue'

const compactFormat = Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
  // @ts-ignore
  // Don't know why Safari(15.6.1+) doesn't honor maximumFractionDigits.
  // Therefore, the experimental roundingPriority is added to force Safari to use the result calculated from maximumFractionDigits.
  roundingPriority: 'lessPrecision'
})
const thousandFormat = Intl.NumberFormat('en-US')
const percentFormat = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
})

// eslint-disable-next-line import/prefer-default-export
export const formatNumber = (value: number | string) => {
  if (!isValidNumber(value)) {
    return MessageConst.EM_DASH
  }

  return value > 1000 ? compactFormat.format(value) : thousandFormat.format(value)
}

export const formatPercent = (value: number | string) => {
  if (!isValidNumber(value)) {
    return MessageConst.EM_DASH
  }
  if (value < 0.001 && value > 0) {
    return '<0.1%'
  }
  return percentFormat.format(value)
}
